import { request } from '../utils/axios-utils';

export const getStyleColorLibraryList = async (data) => {
    const [_blank, companyCode, keySearch, pageNum, pageSize] = data.queryKey;
    const response = await request({
        url: '/referenceLibrary/list',
        method: 'GET',
        params: { companyCode: companyCode || undefined, keySearch: keySearch || undefined, pageNum, pageSize },
    });
    return response.data;
};

export const deleteStyleColorLibrary = (id) => {
    return request({
        url: `/referenceLibrary/${id}`,
        method: 'DELETE',
    });
};
